export const NEXT_DEPLOYMENT_ID = "next";
export const CURRENT_DEPLOYMENT_ID = "current";
export const BLACKFIRE_ID_VARIABLE = "env:BLACKFIRE_SERVER_ID";
